export default __webpack_public_path__ + "static/media/image.3f00f9a2.png";